module.exports = __webpack_public_path__ + "images/logo---132c15fbd32e97b5eeec89ffc3f53d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/header/bar/img/logo/logo.png
// module id = 383
// module chunks = 0